import { _routePoint, } from '../route-model/RoutePoint';
import { _routeLine, } from '../route-model/RouteLine';
const _c_endPoint = (latLng, route) => {
    const innerPoint = route.e(), outerPoint = _routePoint(latLng, 'e', route, {
        pp: innerPoint,
        il: null,
        ol: null,
        np: null,
    }), newLine = _routeLine(route, innerPoint, outerPoint);
    outerPoint.set({ il: newLine });
    return {
        ip: innerPoint,
        op: outerPoint,
        l: newLine,
        r: route,
    };
}, _c_startPoint = (latLng, route) => {
    const innerPoint = route.s(), outerPoint = _routePoint(latLng, 's', route, {
        pp: null,
        il: null,
        ol: null,
        np: innerPoint,
    }), newLine = _routeLine(route, outerPoint, innerPoint);
    outerPoint.set({ ol: newLine });
    return {
        ip: innerPoint,
        op: outerPoint,
        l: newLine,
        r: route,
    };
}, _c_cornerPoint = (latLng, existingLine) => {
    const existingSp = existingLine.sp(), existingEp = existingLine.ep(), route = existingLine.r(), newPoint = _routePoint(latLng, 'c', route, {
        pp: existingSp,
        il: existingLine,
        ol: null,
        np: existingEp,
    }), outgoingLine = _routeLine(route, newPoint, existingEp);
    newPoint.set({ ol: outgoingLine });
    return {
        cp: newPoint,
        pp: existingSp,
        np: existingEp,
        il: existingLine,
        ol: outgoingLine,
        r: route,
    };
};
export { _c_endPoint, _c_startPoint, _c_cornerPoint, };
